/**
 * @param {string} product
 * @param {HTMLButtonElement} button
 */
async function addRemoveFavoritos(product, button) {
  console.log('addRemoveFavoritos');
  const req = await fetch('/apps/upango-favoritos/customers/favoritos/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      shop: Shopify.shop,
      customerid: __st.cid,
      productid: product,
    }),
  });
  if (!req.ok) {
    console.error('No se ha podido añadir/eliminar un favorito.');
    return;
  }
  const res = await req.json();
  console.log('Resultado: ' + JSON.stringify(res));
  if (res.data.favoritos.activo == 1) {
    button.classList.remove('btn-fav-inactivo');
    button.classList.add('btn-fav-activo');
    button.querySelector('.link').textContent = button.getAttribute('data-label-on');
  } else {
    button.classList.remove('btn-fav-activo');
    button.classList.add('btn-fav-inactivo');
    button.querySelector('.link').textContent = button.getAttribute('data-label-off');
  }
}
